import {CALL_API, Schemas} from  '../../../middleware/api'


// ------------------------------------
// List Pacientes
// ------------------------------------

export const GET_ALL_PACIENTES_API_LOADING = 'GET_ALL_PACIENTES_API_LOADING';
export const GET_ALL_PACIENTES_API_SUCCESS = 'GET_ALL_PACIENTES_API_SUCCESS';
export const GET_ALL_PACIENTES_API_ERROR = 'GET_ALL_PACIENTES_API_ERROR';

const fetchAllPacientes = (dni) => ({
  [CALL_API]: {
    method: 'GET',
    types: [ GET_ALL_PACIENTES_API_LOADING, GET_ALL_PACIENTES_API_SUCCESS, GET_ALL_PACIENTES_API_ERROR ],
    endpoint: `/pacientes/search/findByMedicos_Dni?dni=${dni}&projection=minimalPacienteProjection&sort=apellido,asc`
  }
})

export const getAllPacientes = () => (dispatch, getState) => {
  const dni = getState().auth.data.dni
  return dispatch(fetchAllPacientes(dni))
}


export const GET_PACIENTE_BY_ID_MINIMAL_API_LOADING = 'GET_PACIENTE_BY_ID_MINIMAL_API_LOADING';
export const GET_PACIENTE_BY_ID_MINIMAL_API_SUCCESS = 'GET_PACIENTE_BY_ID_MINIMAL_API_SUCCESS';
export const GET_PACIENTE_BY_ID_MINIMAL_API_ERROR = 'GET_PACIENTE_BY_ID_MINIMAL_API_ERROR';

const fetchPacienteByIdMinimal = (id) => ({
  [CALL_API]: {
    method: 'GET',
    types: [ GET_PACIENTE_BY_ID_MINIMAL_API_LOADING, GET_PACIENTE_BY_ID_MINIMAL_API_SUCCESS, GET_PACIENTE_BY_ID_MINIMAL_API_ERROR ],
    endpoint: `/pacientes/${id}?projection=minimalPacienteProjection`
  }
})

export const getPacienteByIdMinimal = (id) => (dispatch, getState) => {
  return dispatch(fetchPacienteByIdMinimal(id))
}



// WEBPACK FOOTER //
// ./src/routes/Pacientes/services/pacientes.js